import Vue from "vue";
import store from "@/store";
import App from "./App.vue";
import router from "@/router";
import vuetify from "@/plugins/vuetify";
import mask from "vue-the-mask";
import moment from "moment";
import "moment/locale/pt-br";
import "@/apps/shared";
import Helper from "./helper";
import { db, storage } from "./apps/shared/firebase";
import VueCropper from "vue-cropper";
import run from "./apps/shared/Onoff";

Vue.use(VueCropper);
Vue.use(mask);
Vue.prototype.$moment = moment;
Vue.config.productionTip = false;
Vue.prototype.$toLocaleString = value => {
  return value.toLocaleString("pt-br");
};
export const EventBus = new Vue();

Vue.prototype.$run = run;

const theme = {
  primary: "#333",
  logo: "logo.jpeg",
  token_img: process.env.VUE_APP_TOKEN_IMG
};

Vue.prototype.$theme = theme;
Vue.prototype.$db = db;
Vue.prototype.$storage = storage;
Vue.prototype.$helper = new Helper();

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount("#app");
